import { Instant } from '@moojo/duration'
import { endpointDeclaration } from '@moojo/endpoints'
import { z } from 'zod'

export const QueryEntry = z.object({
  agentId: z.string(),
  /**
   * The url from which the calibrated agent runs (such as store).
   */
  calibratedUrl: z.string(),
  timestamp: Instant.zod(),
  targetingTagsCriterion: z.record(z.number()),
})
export type QueryEntry = z.infer<typeof QueryEntry>

/**
 * User is identified by a bearer token (Authorization header)
 */
export const GetUserActivityRequest = z.object({})
export type GetUserActivityRequest = z.infer<typeof GetUserActivityRequest>

export const GetUserActivityResponse = z.object({
  queries: QueryEntry.array(),
})

export type GetUserActivityResponse = z.infer<typeof GetUserActivityResponse>

export const getUserActivityDeclaration = endpointDeclaration(GetUserActivityRequest, GetUserActivityResponse)
